import React from 'react';
import { Link } from 'react-router-dom';

const Paneer = () => {
  return (
    <div>
      <div className="bg-gray-100 py-4">
        <div className="container mx-auto px-4">
          <div className="text-sm text-gray-600">
            <Link to="/" className="hover:text-accent">Home</Link> / 
            <Link to="/projects" className="hover:text-accent"> Projects</Link> / 
            <span className="text-gray-900"> Paneer Processing Plant</span>
          </div>
        </div>
      </div>

      <section className="bg-gray-900 text-white py-16">
        <div className="container mx-auto px-4">
          <h1 className="text-5xl font-bold mb-4">Paneer Processing Plant</h1>
          <p className="text-xl text-gray-300">Complete Turnkey Solution</p>
        </div>
      </section>

      <section className="py-12 bg-white">
        <div className="container mx-auto px-4 max-w-5xl">
          <p className="text-lg text-gray-700 mb-8">
            ATHENA provides comprehensive turnkey solutions for Paneer Processing Plant with end-to-end services from design to commissioning.
          </p>
          <div className="grid md:grid-cols-3 gap-6">
            <div className="bg-gray-50 p-6 rounded-lg">
              <h3 className="font-bold text-lg mb-2 text-accent">Design & Engineering</h3>
              <p className="text-gray-600">Custom plant design based on your requirements</p>
            </div>
            <div className="bg-gray-50 p-6 rounded-lg">
              <h3 className="font-bold text-lg mb-2 text-accent">Manufacturing</h3>
              <p className="text-gray-600">High-quality equipment fabrication</p>
            </div>
            <div className="bg-gray-50 p-6 rounded-lg">
              <h3 className="font-bold text-lg mb-2 text-accent">Installation</h3>
              <p className="text-gray-600">Complete installation and commissioning support</p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 bg-black text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold mb-4">Interested in This Project?</h2>
          <Link to="/contact" className="btn-primary px-8 py-3 rounded-lg font-semibold inline-block">
            Get a Quote
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Paneer;
